import React from 'react'
import {   Field} from 'redux-form'
import 'antd/dist/antd.css'

import {  DatePicker} from 'antd';

import moment from 'moment'

export class SVIDDInputEp extends React.Component {

    constructor(props){
        super(props)
        let me= this
        //this.onTripChange_idd_cosmos = this.onTripChange_idd_cosmos.bind(me)
        this.onTripChange_idd_cosmosCurry = this.onTripChange_idd_cosmosCurry.bind(me)
        this.svadcCurryCom =this.svadcCurryCom.bind(me) 
        this.state = {
            filters: {
                
                all: [], // Contains the full data
                //"startDate": "2024-07-22T23:42:55.795+00:00" ,
               // "endDate": "2024-07-22T25:42:55.795+00:00" ,
               startDate : new Date()
            }
        }


    }
    
    onTripChange_idd_cosmosCurry=(onChange ,sfval,ctxThisMe)=>(dateMoment, sdate )=>{
        console.log("****svj22****from**onTripChange_idd_cosmos***")
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd
       
        let moStartDate = moment(fmo)
        console.log(fmd)
      
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        console.log("****svj22****from**onTripChange_idd_cosmos** start_date_s selected str*", mo_ss)
        
      
        let start_date_s   = moStartDate.toISOString() 
       
        console.log("****svj22****from**onTripChange_idd_cosmos** start_date_s*", start_date_s)
        
  
        
        /*
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
        this.setState({filters:f} )
        */
        console.log('sv form change')

  console.log(sdate)
  onChange(sdate)
        /*

let svChange = (values, dispatch, props, valuesPrev)=>{

  console.log('sv form change')

  console.log(values)


}
        */
        onChange(sfval)
    }
    

    onTripChange_idd_cosmos(dateMoment, sdate ){
        //we need curry that gets reduccallnack onChange, value 
        console.log("****svj22****from**onTripChange_idd_cosmos***")
        console.log(sdate)
        let fmd = dateMoment
        let fmo = fmd
       
        let moStartDate = moment(fmo)
        console.log(fmd)
      
        let mo_ss = moStartDate.format('YYYY-MM-DD') 
        console.log("****svj22****from**onTripChange_idd_cosmos** start_date_s selected str*", mo_ss)
        
      
        let start_date_s   = moStartDate.toISOString() 
       
        console.log("****svj22****from**onTripChange_idd_cosmos** start_date_s*", start_date_s)
        
  
        let f = this.state.filters
        let today_dt = new Date()
        f['startDate'] = !fmo ? today_dt :  fmo
        this.setState({filters:f} )
       

    }
    
    svadcCurryCom =(param1, ctxThis)=>(o)=>{
        console.log("*******svj22****curry** START")
  console.log(param1)
 
  console.log(ctxThis)

  console.log(o)
  const { input: { onChange, value } } = o
  console.log("*******svj22****redux vaalue**")
  console.log(value)
  let vob = value
  let vob_date = value._d
  console.log(vob_date)
  let STARTDATE_ITN_TZAWARE_EST  = "2025-11-25"
  let mo_ss = moment(STARTDATE_ITN_TZAWARE_EST, 'YYYY-MM-DD');
  let mofval = null
if( value != null){
    mofval =moment(vob_date) 
    let mofval_str = mofval.format('YYYY-MM-DD') 
  
    console.log("*******svj22****mofval_stre**")
    
    console.log(mofval_str)
   
  
    
    let mom_value = !value ? mo_ss :mofval_str
}else{
    mofval = mo_ss
}
 
let TIME_NO = false
 
  /*
  onChange={onChange}
    format="DD MMM YYYY"
    time={showTime}
    value={!value ? null : new Date(value)}
  />

  */
  let {onTripChange_idd_cosmos} = ctxThis
        return ( <DatePicker showTime={TIME_NO} onChange={onChange} value={mofval}  />)


    }
    render(){
        console.log('render sviddinputEp date add')

        let me = this
        let {member} = this.props
         
        let param1 = "1974-01-14"


        return (

            <Field
             name={`${member}.issuanceDate`} 
             type="text"
            className="form-control"
            component={this.svadcCurryCom(param1,this)}
            />
        )


    }

}